export enum RefreshStatus {
	AVAILABLE = 'available',
	IN_PROGRESS = 'in-progress',
	COMPLETE = 'complete'
}